// @flow
import type { Message } from 'types/message'

import { API, ApiBase } from './api'
import { makeGetRequest, makePostRequest } from './fetchCalls'
// todo: move messages requests from ./index to here

export async function getMessage(id: string): Promise<Message> {
  return await makeGetRequest(`${ApiBase}/message/${id}`)
}

export async function createInternalMessage(data: {
  customer: number,
  team: string,
  form?: string,
  document?: string,
}): Promise<Message> {
  return await makePostRequest(API.MESSAGE.CREATE_MESSAGE, {
    body: JSON.stringify({ ...data, message_type: 'internal' }),
  })
}
